import { render } from "./Textbox.vue?vue&type=template&id=7ec598f0"
import script from "./Textbox.vue?vue&type=script&lang=ts"
export * from "./Textbox.vue?vue&type=script&lang=ts"
script.render = render

export default script